<template>
    <div>
      <el-row>
        <el-col :span="8">
          <div style="width: 420px;height:860px;box-shadow:5px 5px 2px #000 inset,5px 5px 10px #666; border-radius: 30px; border: 12px solid #000;">
            <div style="width:101%;height: 40px; background-color: #000; display: flex; align-items: center; justify-content: center;">
              <span style="color: #fff;">手机模拟</span>
            </div>
            <div style="padding: 10px;">
              <el-carousel height="240px" indicator-position="outside">
                <el-carousel-item v-for="item in lbtdata" :key="item">
                  <div v-if="item.urltype === 1" style="height:100%; width:100%;">
                    <el-image
                      :src="item.img_url"
                      style="height:100%; width:100%;"
                      fit="cover"></el-image>
                  </div>
                  <div v-if="item.urltype === 2" style="height:100%; width:100%;">
                    <video :src="item.img_url" controls style="height:100%; width:100%;"></video>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <el-collapse v-model="activeNames" style="width:386px;max-height:500px;overflow-y:auto;">
                <el-collapse-item title="基础信息" name="1">
                  <div style="color: #000; padding: 15px;height:100px">
                    <div>
                      产品名称：{{editgoods.name}}
                    </div>
                    <div style="margin-top: 10px; color: darkred">
                      价格：
                      <span style="font-size: 18px;"> {{editgoods.baseprice}} </span>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="属性信息" name="2">
                  <div style="flex: 1;">
                    <div style="margin: 10px 0 0 20px; color: darkred">
                      <div v-for="(item,index) in edattrs" :key="index" style="margin-bottom: 10px;">
                        <div>{{item.attrname}}: <span style="margin-left: 10px; color: #cccccc">{{item.attrvalue}}</span></div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="规格信息" name="3">
                  <div style="margin: 10px 0 0 0px; color: darkred; display: flex; flex-flow: row wrap; width: 100%;">
                    <el-button style="margin: 10px 0 0 10px;" type="info" plain disabled v-for="(item,index) in edspec" :key="index">{{item.attrname}}</el-button>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="产品描述" name="4">
                  <div style="padding: 10px;">
                    <span v-html="pagecontext"></span>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <el-tabs style="margin-left: 20px;" v-model="editgtab" type="card" @tab-click="tab_change">
            <el-tab-pane label="图片" name="gimg">
              <EGImg :hidden="egivisible" ref="egi"></EGImg>
            </el-tab-pane>
            <el-tab-pane label="基本信息" name="ginfo">
              <EGoodsBase :hidden="egvisible" @colsepage="colsepage" @qgoods="qgoods" ref="gb"></EGoodsBase>
            </el-tab-pane>
            <el-tab-pane label="属性" name="gattr" style="padding: 20px;">
              <EMAttrs :hidden="mavisible" @loadattrs="loadattrs" ref="em"></EMAttrs>
            </el-tab-pane>
            <el-tab-pane label="规格" name="gspec" style="padding: 20px;">
              <EMSpec :hidden="msvisible" @loadspecs="loadspecs" ref="ems"></EMSpec>
            </el-tab-pane>
            <el-tab-pane label="描述" name="gdes">
              <quill-editor
                ref="myQuillEditor"
                :options="editorOption"
                @change="onEditorChange($event)"
                style="margin-left: 20px; margin-top: 10px; min-height: 500px;"
                v-model="pagecontext"
              >
              </quill-editor>
              <el-button type="primary" style="float: right; margin-right: 10px;" icon="el-icon-edit" @click="savecpms" round>更新描述</el-button>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-dialog :title="selectuppathtitle" :visible.sync="visupfilepanel">
        <el-row>
          <el-col :span="12">
            <el-form  label-width="120px">
              <el-form-item label="上传资料" class="yyzz_upload">
                <el-upload
                  class="avatar-uploader"
                  drag
                  action=""
                  :on-success="fnUploadSuccess"
                  :headers="uploadHeaders"
                  :show-file-list="true"
                  :http-request="fnUploadRequest"
                  :limit="files">
                </el-upload>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item title="上传说明" name="1">
                <div>1、您可以上传任何类型的资料。</div>
                <div>2、上传前一定要看好上传的路径！</div>
                <div>3、上传时，上传文件下方会有上传进度。</div>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import * as Quill from 'quill'
  import Utils from '../../util/utils'
  import Video from '../../util/video'
  import {quillRedefine} from 'vue-quill-editor-upload'
  import {quillEditor} from 'vue-quill-editor'
  import EGoodsBase from './EGoodsBase'
  import EMAttrs from './EMAttrs'
  import EMSpec from './EMSpec'
  import EGImg from './EGImg'
  var OSS = require('ali-oss')
  Quill.register(Video, true)
  Vue.prototype.$http = axios
  var that
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{ script: 'sub' }, { script: 'super' }],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['link', 'image', 'video'],
    ['clean']
  ]
  export default {
    name: 'GShow',
    components: {
      quillEditor,
      quillRedefine,
      EGoodsBase,
      EMAttrs,
      EGImg,
      EMSpec
    },
    data () {
      return {
        editgtab: 'ginfo',
        lbtdata: [],
        activeNames: ['1','2','3','4'],
        lbt_act: 'lbt',
        drawer: false,
        edattrs: [],
        edspec: [],
        pagecontext: '',
        sltlist: [],
        lbtlist: [],
        movlist: [],
        egivisible: false,
        egvisible: false,
        mavisible: false,
        msvisible: false,
        selectuppathtitle: '',
        visupfilepanel: false,
        upfiletype: 'image',
        selectpath: '',
        editorOption: {},
        activeName: ['1'],
        files: 100,
        uppercent: 0,
        uploadHeaders: {
          authorization: ''
        },
        filemodel: 'new',
        khid: '',
        editgoods: ''
      }
    },
    created: function () {
      this.editorOption =
        {
          uploadConfig: {
            methods: 'POST',
            res: (respnse) => {
              console.log(respnse)
              return respnse.info
            }
          },
          methods: 'POST',
          size: 5100,
          accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
          // input点击事件  formData是提交的表单实体
          change: (formData) => {
          },
          // 设置请求头 xhr: 异步请求， formData: 表单对象
          header: (xhr, formData) => {
            // xhr.setRequestHeader('myHeader','myValue');
            // formData.append('token', '1234')
          },
          // start: function (){}
          start: () => {
          },
          end: () => {
          },
          success: () => {
            console.log('上传成功')
          },
          error: () => {
          },
          placeholder: '请在此输入内容',
          theme: 'snow',
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function (value) {
                  that.visupfilepanel = true
                  that.selectuppathtitle = '上传图片'
                  that.upfiletype = 'image'
                },
                'video': function (value) {
                  that.visupfilepanel = true
                  that.selectuppathtitle = '上传视频'
                  that.upfiletype = 'video'
                }
              }
            }
          }
        }
    },
    mounted () {
      that = this
      if (getCookie('cusid') !== 0 || getCookie('cusid') !== '' || getCookie('cusid') !== undefined) {
        this.khid = getCookie('cusid')
      } else {
        this.khid = 1
      }
      if (that.khid === null) {
        that.$message({
          type: 'info',
          message: 'Cookie已失效，请重新登录!'
        })
        that.$router.push({path: '/'})
      } else {
      }
    },
    methods: {
      colsepage () {
        that.$emit('colsepage');
      },
      reloaddata () {
        window.console.log('重新加载数据')
        that.getlbtlist()
        that.getgdes()
        setTimeout(() => {
          this.$refs.egi.showimg(localStorage.getItem('editgoodsid')) // 方法1:触发监听事件
          this.$refs.gb.showbaseinfo(localStorage.getItem('editgoodsid')) // 方法1:触发监听事件
          this.$refs.em.initattrs(localStorage.getItem('editgoodsid')) // 方法1:触发监听事件
          this.$refs.ems.showspec(localStorage.getItem('editgoodsid')) // 方法1:触发监听事件
        },0)
      },
      loadattrs () {
        window.console.log('读取属性')
        that.edattrs = JSON.parse(localStorage.getItem('edattrs'))
      },
      loadspecs () {
        that.edspec = JSON.parse(localStorage.getItem('edspec'))
      },
      qgoods () {
        that.editgoods = JSON.parse(localStorage.getItem('curegdata'))[0]
        that.$emit('qgoods');
      },
      getlbtlist () {
        var qstr = {
          whereinfo: 'pos=1 and goods_id = ' + localStorage.getItem('editgoodsid') + " and ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygimgs',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.lbtdata = res.data
            } else {
              that.lbtdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      tab_change () {},
      showedit () {},
      savecpms () {
        console.log(this.pagecontext)
        var adata
        adata = {
          goods_id: localStorage.getItem('editgoodsid').toString(),
          des: this.pagecontext,
          ownphone: localStorage.getItem('username'),
          cusid: localStorage.getItem('cusid').toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addgdes',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.getgdes()
              that.$message({
                type: 'success',
                message: '保存描述成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getgdes () {
        var qstr = {
          whereinfo: 'goods_id = ' + localStorage.getItem('editgoodsid'),
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygdes',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.length > 0) {
              var cuszl = res.data
              console.log(cuszl)
              that.pagecontext = cuszl[0].des
            } else {
              that.pagecontext = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      preaimg () {
        that.$emit('preaimg');
      },
      OnUpFileSuccess (res, file, fileList) {
        if (res.success) {
          if (this.upfiletype === 'image') {
            this.pagecontext = this.pagecontext + '<p><img src="' + res.data[0].osspath + '"></p>'
          } else if (this.upfiletype === 'video') {
            this.pagecontext = this.pagecontext + '<p> 增加的视频资料 '
            this.pagecontext = this.pagecontext + '<p><video class="videoinfo" id="videoinfo" src="' + res.data[0].osspath + '" controls="controls" loop="loop"> </video></p>'
            this.pagecontext = this.pagecontext + '</p>'
          }
        }
      },
      OnUpFileError (res) {},
      BeforeUpFileUpload (file) {},
      onEditorChange ({editor, html, text}) {
        console.log('---内容改变事件---')
        console.log(html)
      },
      randomString (num) {
        let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        let res = ''
        for (let i = 0; i < num; i++) {
          var id = Math.ceil(Math.random() * 35)
          res += chars[id]
        }
        return res
      },

      /**
       * 创建oss客户端对象
       * @returns {*}
       */
      createOssClient () {
        return new Promise((resolve, reject) => {
          let client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: 'LTAIaf73dyK72dHv',
            accessKeySecret: 'GRv2JMOvMC02F402r2ZHBElebVUB9v',
            bucket: 'sqpro'
          })
          resolve(client)
        })
      },
      /**
       * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
       * @author   yangxiaoshuo
       * @param    {object}   option [上传选项]
       * @return   {null}   [没有返回]
       */
      async fnUploadRequest (option) {
        var that = this
        let file = option.file
        const self = this
        return new Promise((resolve, reject) => {
          let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
          console.log(date)
          let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
          let randomStr = self.randomString(4)//  4位随机字符串
          let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
          console.log(dateTime)
          console.log(randomStr)
          console.log(extensionName)
          let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
          // 执行上传
          self.createOssClient().then(client => {
            // 异步上传,返回数据
            resolve({
              fileName: file.name,
              fileUrl: fileName
            })
            // 上传处理
            // 分片上传文件
            client.multipartUpload(fileName, file, {
              progress: function (p) {
                let e = {}
                e.percent = Math.floor(p * 100)
                // console.log('Progress: ' + p)
                option.onProgress(e)
                that.uppercent = e.percent
                console.log(e.percent)
              }
            }).then((val) => {
              if (val.res.statusCode === 200) {
                option.onSuccess(val)
                return val
              } else {
                option.onError('上传失败')
              }
            }, err => {
              option.onError('上传失败')
              reject(err)
            })
          }).catch(errinfo => {
          })
        })
      },
      /**
       * @description [fnUploadSuccess 文件上传成功的函数]
       * @author   shanshuizinong
       * @return   {null}  [没有返回]
       */
      async fnUploadSuccess (res, file, fileList) {
        console.log(res)
        if (res.res.status === 200) {
          var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
          console.log(uppath)
          console.log(this.upfiletype)
          if (this.upfiletype === 'image') {
            this.pagecontext = this.pagecontext + '<p><img src="' + uppath + '"></p>'
          } else {
            this.pagecontext = this.pagecontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
          }
          console.log(this.pagecontext)
        }
        // TODO
      },
      showimg () {
        this.$emit('showimg');
      },
      showbaseinfo () {
        this.$emit('showbaseinfo');
      },
      showattrinfo () {
        this.$emit('showattrinfo');
      },
      showspecinfo () {
        this.$emit('showspecinfo');
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>
  .imginfo {
    width: 100px;
    height: 100px;
    background:skyblue;
    border-radius:5px;/*4个值分别代表上、右、下、左*/
    box-shadow:4px 4px 4px -3px #666;
  }
  .lbtimginfo {
    height: 200px;
  }
  .card {
    display: flex;
    flex-flow: row;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    padding: 8px 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/newgoods/GShow.vue